/**
 * Created by Alan Yang on 8/17/17.
 * Description:
 *
 * ------ maintenance history ------
 * some entity doesn't have template on server so set default template for it.
 */

import { Injectable } from '@angular/core';
import { businessConstants } from '../constants/business.constants';

@Injectable()
export class DefaultEntityTemplateConfigService {
    constructor() { }

    public static getDefaultEntityTemplateConfig() {

        const tamaleNote = {
            'noteType': {
                'id': businessConstants.EntryTypes.Tamale_Note_Id,
                'name': 'TamaleNote'
            },
            'width': '527',
            'contains': [
                [
                    {
                        'isLabelHidden': false,
                        'isHidden': false,
                        'labelWidth': '80',
                        'heigh': '26',
                        'width': '527',
                        'label': 'Name:        ',
                        'controlID': 'NAME',
                        'TypeName': 'LayoutControlItem',
                        'componentType': 'name-input'
                    }
                ],
                [
                    {
                        'isLabelHidden': false,
                        'isHidden': false,
                        'labelWidth': '80',
                        'heigh': '26',
                        'width': '527',
                        'label': 'Shortname:        ',
                        'controlID': 'SHORTNAME',
                        'TypeName': 'LayoutControlItem',
                        'componentType': 'shortname-input'
                    }
                ]
            ],
            'entityTypeId': businessConstants.EntityTypes.Corporate_Id
        };

        return tamaleNote;
    }
}
